<template>
  <div id="person_setting_outer" v-if="user != null">
    <div :class="[specifiedBorderColor]">
      <div v-if="showRealNameDiv" class="realname-verify">
        <span :class="['iconfont', isRealName ? 'color-green' : 'color-gray']">&#xe654;</span>
        <div :class="['setting_context', specifiedBorderColor]" style="border: none;">
          <a href="javascript:void(0)" @click="realNameInforsShow" >实人认证</a>
        </div>
        <div class="setting_right_button" style="width: 91px;"></div>
      </div>
      <div id="phone_reset" :class="[specifiedPhoneImg]">

        <div :class="['setting_context', specifiedBorderColor]">{{userPhone}}</div>
        <input :class="['setting_right_button', specifiedBackgroundColor]" type="button" :value="user.mobile == null ? '绑定' : '更换'" @click="renewPhone">
      </div>
      <div v-if="user.isTeam == 0" id="wechat_reset" :class="[specifiedWechatImg]">
        <div :class="['setting_context', specifiedBorderColor]">{{user.vx != null ? user.vx : '暂无'}}</div>
        <input :class="['setting_right_button', specifiedBackgroundColor]"
               type="button"
               @click="resetWechatButtonClicked"
               :value="user.vxUnionid == null ? '绑定' : '更换'">
      </div>
      <div id="pwd_reset" :class="[specifiedPwdImg]">
        <input :class="['setting_pwd_button', specifiedBackgroundColor]" type="button" :value="user.password  == null ? '设置账户登录' : '修改密码'" @click="renewPassword">
      </div>
    </div>
    <bing-phone-number v-if="showPhoneDialog" v-on:close="closePhoneDialog" :theme="themeValue" />
    <bind-password v-if="showPasswordDialog" v-on:close="showPasswordDialog = false" :theme="themeValue" />
    <bind-wechat v-if="showWechatDialog" v-on:close="closeWechatDialog"/>

    <real-name-dialog v-if="showRealNameDialog" v-on:closeDialog="showRealNameDialog = false" />

  </div>
</template>

<script>

import BingPhoneNumber from "../settings/BingPhoneNumber";
import BindPassword from "../settings/BindPassword";
import BindWechat from "../settings/BindWechat";
import RealNameDialog from "../settings/RealNameDialog";
export default {
  name: "PersonalSetting",
  props: {
  },
  components: {
    BingPhoneNumber,
    BindPassword,
    BindWechat,
    RealNameDialog
  },
  data() {
    return {
      title: '账户设置',
      showPhoneDialog: false,
      showPasswordDialog: false,
      showWechatDialog: false,
      showRealNameDialog: false,
      currentUser: null,
    }
  },
  computed: {
    user() {
      if (this.currentUser == null) {
        this.currentUser = this.$store.state.user;
      }
      return this.currentUser;
    },

    isRealName () {
      let user = this.user;
      if (user == null) {
        return false;
      }
      let isIdentification = user.isIdentification;
      let name = user.name;
      if (name == null) {
        name = "";
      }
      let idNumber = user.idNumber;
      if (idNumber == null) {
        idNumber = "";
      }
      return (isIdentification == 1 && name.length > 0 && idNumber.length > 0);
    },

    showRealNameDiv() {
      if (this.user == null) {
        return false;
      }
      return (this.user.isTeam == 0)
    },

    isVip() {
      if (this.user == null) {
        return false;
      }
      let user = this.user;
      let memberValidDate = user.memberValidDate;
      if (memberValidDate == null) {
        return false;
      }
      return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
    },

    themeValue() {
      return this.isVip ? 1 : 0
    },

    userPhone() {
      let phone = this.user.mobile;
      if (phone == null) {
        return '暂无';
      }

      let phoneList = phone.split('');
      let newPhone = '';
      for (let i = 0; i < phoneList.length; i++) {
        let item = phoneList[i];
        if (i < 3 || i > 7) {
          newPhone += item;
        } else {
          newPhone += '*'
        }
      }
      return newPhone;

    },

    specifiedBorderColor() {
      return this.themeValue == 0 ? "shba-no-vips-border-color" : "shba-vips-border-color";
    },

    specifiedBackgroundColor() {
      return this.themeValue == 0 ? "shba-no-vips-background-color" : "shba-vips-background-color";
    },

    specifiedPhoneImg() {
      return this.themeValue == 0 ? "phone-red" : "phone-gold";
    },
    specifiedWechatImg() {
      return this.themeValue == 0 ? "wechat-red" : "wechat-gold";
    },
    specifiedPwdImg() {
      return this.themeValue == 0 ? "pwd-red" : "pwd-gold";
    },
  },
  mounted() {
    let showWechatDialog = this.$store.state.showWechatDialog;
    if (showWechatDialog) {
      this.showWechatDialog = showWechatDialog;
      this.$store.commit('setShowWechatDialog', false);
    }
  },
  methods: {

    realNameInforsShow() {
      if (!this.isRealName) {
        return;
      }
      this.showRealNameDialog = true;
    },

    renewPhone() {
      let password = this.user.password;
      if (password == null) {
        this.$toast('请先设置账号登录！');
      } else {
        this.showPhoneDialog = true;
      }
    },
    renewPassword() {
      this.showPasswordDialog = true;
    },
    resetWechatButtonClicked() {
      this.showWechatDialog = true;
    },
    closeWechatDialog() {
      this.currentUser = null;
      this.showWechatDialog = false;

    },
    closePhoneDialog() {
      this.currentUser = null;
      this.showPhoneDialog = false;
    }
  }
}
</script>

<style scoped>

  #person_setting_outer {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 40px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
    position: relative;
  }

  #person_setting_outer input {
    outline: none;
  }

  #person_setting_outer > div:first-child {
    width: 100%;
    min-width: 290px;
    /*max-width: 800px;*/
    min-height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 50px;
    padding-bottom: 50px;
    padding-left: 5px;
    padding-right: 5px;
  }



  #phone_reset, #wechat_reset, #pwd_reset {
    height: 50px;
    line-height: 50px;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    background-position: left center;
    width: 90%;
  }

  #person_setting_outer .realname-verify {
    width: 90%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    position: relative;
  }

  #person_setting_outer .realname-verify .setting_context {
    /*width: 55%;*/
  }

  #person_setting_outer .realname-verify .iconfont {
    top: 50%;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    position: absolute;
    left: 0;
    font-size: 1.3rem;
    font-weight: bold;
  }

  #person_setting_outer .realname-verify .color-gray {
    color: lightgrey;
  }

  #person_setting_outer .realname-verify .color-green {
    color: green;
  }


  @media screen and (min-width: 768px){
    #phone_reset, #wechat_reset, #pwd_reset {
      width: 60%;
      max-width: 600px;
    }

    #person_setting_outer .realname-verify {
      width: 60%;
      max-width: 600px;
    }

    #person_setting_outer > div:first-child {
      padding-left: 4vw;
      padding-right: 4vw;
    }
  }

  #phone_reset {
    /*background-image: url("../../assets/shl_setting_phone_reset.png");*/
    background-size: 20px auto;
  }

  #wechat_reset {
    /*background-image: url("../../assets/shl_setting_wechat_reset.png");*/
    background-size: auto 20px;
  }

  #pwd_reset {
    /*background-image: url("../../assets/shl_setting_pwd_reset.png");*/
    background-size: 20px auto;
  }

  .phone-gold {
    background-image: url("../../assets/shl_setting_phone_reset.png");
  }

  .phone-red {
    background-image: url("../../assets/shl_setting_phone_reset_red.png");
  }

  .wechat-gold {
    background-image: url("../../assets/shl_setting_wechat_reset.png");
  }

  .wechat-red {
    background-image: url("../../assets/shl_setting_wechat_reset_red.png");
  }

  .pwd-gold {
    background-image: url("../../assets/shl_setting_pwd_reset.png");
  }

  .pwd-red {
    background-image: url("../../assets/shl_setting_pwd_reset_red.png");
  }


  .setting_context {
    margin-left: 10%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    /*width: 20vw;*/
    font-size: 1rem;
    color: #333;
    border-radius: 2px;
    width: 60%;
    min-width: 110px;
  }

  .setting_context > a {
    color: #333;
    text-decoration: none;
  }

  .setting_context > a:hover {
    color: #e71432;
  }

  .setting_right_button {
    font-size: 1rem;
    color: white;
    border: none;
    border-radius: 14px;
    padding-left: 30px;
    padding-right: 30px;
    height: 28px;
    line-height: 28px;
    margin-left: 25px;
  }

  .setting_pwd_button {
    height: 30px;
    font-size: 1rem;
    color: white;
    border: none;
    border-radius: 15px;
    padding-left: 30px;
    padding-right: 30px;
    line-height: 30px;
    margin-left: 15%;
    width: 50%;
    min-width: 180px;
  }


</style>



// WEBPACK FOOTER //
// src/components/personal/PersonalSetting.vue